"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECEIPT_TEMPLATE = exports.KITCHEN_TEMPLATE = exports.KITCHEN_DOCKET_58MM = exports.LRG_KITCHEN_DOCKET = exports.SML_KITCHEN_DOCKET = void 0;
exports.SML_KITCHEN_DOCKET = 'Kitchen Template - Small Font Size';
exports.LRG_KITCHEN_DOCKET = 'Kitchen Template - Large Font Size';
exports.KITCHEN_DOCKET_58MM = 'Kitchen Template - 58mm';
exports.KITCHEN_TEMPLATE = 'Kitchen Template';
exports.RECEIPT_TEMPLATE = 'Receipt Template';
//# sourceMappingURL=printerTemplates.js.map